import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { DateTimeSelect } from './DateTimeSelect';
import { ConditionalBlock } from '../../ConditionalBlock';
import { TIME_LIST } from '../../services/Util'
import { MultiSelect } from '../MultiSelect';
import APIUrls from '../../services/APIUrls'
import { getAxiosResponse, postAxiosResponse } from '../../services/authApiRoutes/APImethods'

export const TranslationPreference = ({componentId, userCurrentDateTime, language, bidLessFeatureEnabled, autoApproveFeatureEnabled, bidLessVendors, biddingVendors, validateForm, onValidation, preferenceData}) => {

    const { t } = useTranslation();
	const translate = t;

	const [receiveQuotes, setReceiveQuotes] = useState(true);
	const [autoApproveBidRequest,setAutoApproveBidRequest]=useState(false)
	const [selectedVendors , setSelectedVendors] = useState([]);
    const [bidDueDate, setBidDueDate] = useState(null);
    const [deliveryDueDate, setDeliveryDueDate] = useState(null);
    const [bidDueDateTime, setBidDueDateTime] = useState(-1);
    const [deliveryDueDateTime, setDeliveryDueDateTime] = useState(-1);
	const [bidDueDateHours, setBidDueDateHours] = useState([]);
	const [deliveryDueDateHours, setDeliveryDueDateHours] = useState([]);
	const [validationErrorMessage , setValidationErrorMessage] = useState({});

    const autoApproveBidRequestChanged = (event) =>{
        setAutoApproveBidRequest(event.target.checked);
    }

    const setTranslationType = (receiveQuotesSelected) => {
        setReceiveQuotes(receiveQuotesSelected);
        setSelectedVendors([]);
        setAutoApproveBidRequest(false);
    }

    const selectVendor = (vendor) => {
        setSelectedVendors([vendor]);
    }

    const selectVendors = (vendors) => {
        if(vendors?.length != 1){
            setAutoApproveBidRequest(false);
        }
        setSelectedVendors(vendors);
    }

    const bidDueDateChanged = (date, time) => {
        setBidDueDate(date);
        setBidDueDateTime(time);

        if(deliveryDueDate && date && deliveryDueDate.getTime() === date.getTime()){
            let minDeliveryTime = (time+4)>23 ? 23 : (time+4);
            let newHours = deliveryDueDateHours.map(hour => {
                if (hour && hour.value < minDeliveryTime) {
                    hour.isdisabled = true;
                }
                return hour;
            });

            setDeliveryDueDateHours(newHours);
            if(!deliveryDueDateTime || deliveryDueDateTime < minDeliveryTime){
                setDeliveryDueDateTime(minDeliveryTime);
            }
        }

    }

    const deliveryDueDateChanged = (date, time) => {

        setDeliveryDueDate(date);
        setDeliveryDueDateTime(time);

        if(bidDueDate && date && bidDueDateTime && bidDueDate.getTime() === date.getTime()){
            let minDeliveryTime = (bidDueDateTime+4)>23 ? 23 : (bidDueDateTime+4);
            let newHours = deliveryDueDateHours.map(hour => {
                if (hour && hour.value < minDeliveryTime) {
                    hour.isdisabled = true;
                }
                return hour;
            });

            setDeliveryDueDateHours(newHours);
            if(!deliveryDueDateTime || deliveryDueDateTime < minDeliveryTime){
                setDeliveryDueDateTime(minDeliveryTime);
            }
        }

    }

    const validateData = async() => {
        let errorMsg = {};
        if(selectedVendors === null || selectedVendors.length === 0){
            errorMsg.selectedVendors = 'Please select vendor(s).';
        }

        if(receiveQuotes && (bidDueDate === null || bidDueDate === "")){
            errorMsg.bidDueDate = 'Please enter a valid date.';
        }

        if(deliveryDueDate === null || deliveryDueDate === ""){
            errorMsg.deliveryDueDate = 'Please enter a valid date.';
        }

        if(validateForm && onValidation){//in case of validation triggered explicitly

            const validationFailed = (Object.keys(errorMsg).length !== 0);

            let data = {
                language : language.language,
                receiveQuotes: receiveQuotes,
                autoApproveBidRequest : autoApproveBidRequest,
                bidDueDate: getDateWithTime(bidDueDate, bidDueDateTime),
                deliveryDueDate: getDateWithTime(deliveryDueDate, deliveryDueDateTime),
                vendors: selectedVendors,
                validationFailed : validationFailed
            };

            if(!validationFailed){//do server validation only if client side validation are fixed and in case of explicit validation only

                 await postAxiosResponse(APIUrls.VALIDATE_TRANSLATION_PREFERENCE, data)
                 .then((res)=>{
                    if(res?.data?.code === 400 && res?.data?.message !== ""){
                        errorMsg[res.data.message] = res.data.data;
                        data.validationFailed = true;
                    }
                  });
            }
            onValidation(data);
        }

        setValidationErrorMessage(errorMsg);
        return errorMsg;
    }

    const getDateWithTime = (date, time) => {
        let dateTime = date;
        if(dateTime !== null && dateTime !== undefined && time !== null && time >= 0 && time <=23){
            dateTime.setHours(time);
        }
        return dateTime;
    }

    //fill redux data in form
    const fillSelectedData = (preferenceData) => {

        if(preferenceData?.vendors?.length > 0){
            setSelectedVendors(preferenceData?.vendors);
        }

        if(preferenceData?.receiveQuotes !== null && preferenceData?.receiveQuotes !== undefined && preferenceData?.receiveQuotes !== ''){
            setReceiveQuotes(preferenceData?.receiveQuotes);
        }

        if(preferenceData?.autoApproveBidRequest !== null && preferenceData?.autoApproveBidRequest !== undefined && preferenceData?.autoApproveBidRequest !== ''){
            setAutoApproveBidRequest(preferenceData?.autoApproveBidRequest);
        }

        if(preferenceData?.bidDueDate){
            setBidDueDate(preferenceData?.bidDueDate);
            setBidDueDateTime(preferenceData?.bidDueDate?.getHours());
        }

        if(preferenceData?.deliveryDueDate){
            setDeliveryDueDate(preferenceData?.deliveryDueDate);
            setDeliveryDueDateTime(preferenceData?.deliveryDueDate?.getHours());
        }

    }

    //initialize data
    useEffect(()=>{
        fillSelectedData(preferenceData);
    },[preferenceData]);

    // if  the fields are changed and there are errors then validate and clean the errors
    useEffect(()=>{
        if(Object.keys(validationErrorMessage).length !== 0){
            validateData();
        }
    },[bidDueDate, deliveryDueDate, selectedVendors]);

    //if need to validate the form explicitly
    useEffect(()=>{
        if(validateForm){
            validateData();
        }
    },[validateForm]);

    useEffect(()=>{
        setBidDueDateHours(TIME_LIST.map(t=>Object.assign({},t)));
        setDeliveryDueDateHours(TIME_LIST.map(t=>Object.assign({},t)));
    },[]);

    return (
        <>
              <div className="target-lang-list">
                <div className="inline-flex">
                  <button className="light-gray-btn">{language.display}</button>
                  <ConditionalBlock condition={(bidLessFeatureEnabled && bidLessVendors?.length > 0)}>
                    <div className="group-radio-list" role="radiogroup" aria-labelledby="radioDesc">
                        <p id='radioDesc'>{translate("project_listing.prior_translation")}</p>
                        <div className="flex">
                            <div className="radio-form-check">
                                <input type="radio" onChange={() => setTranslationType(true)} value={receiveQuotes} checked={receiveQuotes} className="form-check-input" name={componentId+'-radio'} id={componentId+'-radio-yes'} />
                                <label className="form-check-label" htmlFor={componentId+'-radio-yes'}>
                                    Yes
                                </label>
                            </div>
                            <div className="radio-form-check">
                                <input type="radio" onChange={() => setTranslationType(false)} value={receiveQuotes} checked={!receiveQuotes} className="form-check-input" name={componentId+'-radio'} id={componentId+'-radio-no'} />
                                <label className="form-check-label" htmlFor={componentId+'-radio-no'}>
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                  </ConditionalBlock>
                </div>

                <ConditionalBlock condition={(autoApproveFeatureEnabled && receiveQuotes)}>
                    <div className="approve-block">
                        <h5>Automatically approve quote?</h5>
                        <p>Select the option below to have the quote submitted by the vendor automatically approved. This option is only available when the project is sent to only one of your preferred vendors listed above.</p>
                        <div className="radio-form-check">
                            <input  disabled={(selectedVendors !=null && selectedVendors.length !==1)} checked={autoApproveBidRequest} value={autoApproveBidRequest} onChange={autoApproveBidRequestChanged} type="checkbox" className="form-check-input" name="auto-approve" id={componentId+'-radio-auto-approve'}/>
                            <label className="form-check-label" htmlFor={componentId+'-radio-auto-approve'}>
                                Yes - automatically approve quote submitted by Vendor
                            </label>
                        </div>
                    </div>
                </ConditionalBlock>

                <div className="vender-form-block flex">

                 {
                    receiveQuotes
                    ?
                   <>
                    <div className="flex wrap-dropdown">
                         <div className="global-dropdown-block global-multidropdown-check flex-center global-multidropdown-breakline" role="listbox" arial-label="dropdown">
                            <label>Vendor Selection</label>
                            <div className="global-dropdown-select language-dropdown">
                                <MultiSelect
                                    options={biddingVendors}
                                    selectedValues={selectedVendors}
                                    onChange={e => selectVendors(e)}
                                />
                            </div>
                            <ConditionalBlock condition={validationErrorMessage.selectedVendors}>
                                <p className='textDanger'>{validationErrorMessage.selectedVendors}</p>
                            </ConditionalBlock>
                         </div>
                     </div>

                     <div className="flex wrap-dropdown wrap-group-dropdown" role="listbox" arial-label="dropdown" tabIndex="0">
                         <div className="global-dropdown-block flex-center">
                             <label>Quote Due Date</label>
                             <div className="flex-center w-d100">
                                <DateTimeSelect todayDate={userCurrentDateTime} dateValue={bidDueDate} timeValue={bidDueDateTime}
                                onDateChange={bidDueDateChanged}
                                timeOptions={bidDueDateHours} />
                             </div>
                             <ConditionalBlock condition={validationErrorMessage.bidDueDate}>
                                <p className='textDanger'>{validationErrorMessage.bidDueDate}</p>
                             </ConditionalBlock>
                         </div>
                     </div>
                    </>
                    :
                    <div className="flex wrap-dropdown">
                         <div className="global-dropdown-block flex-center" role="listbox" arial-label="dropdown">
                             <label>Vendor Selection</label>
                             <div className="global-dropdown-select">
                                <Select className="global-dropdown-select" classNamePrefix='cw' aria-label="Vendor Selection"
                                    options={bidLessVendors}
                                    value={selectedVendors}
                                    onChange={e => selectVendor(e)}
                                    menuShouldScrollIntoView={false}
                                />
                             </div>
                             <ConditionalBlock condition={validationErrorMessage.selectedVendors}>
                                <p className='textDanger'>{validationErrorMessage.selectedVendors}</p>
                             </ConditionalBlock>
                         </div>
                    </div>
                 }



                    <div className="flex wrap-dropdown wrap-group-dropdown" role="listbox" arial-label="dropdown" tabIndex="0">
                        <div className="global-dropdown-block flex-center">
                             <label>Translation Due Date</label>
                             <div className="flex-center w-d100">
                                <DateTimeSelect todayDate={bidDueDate || userCurrentDateTime} dateValue={deliveryDueDate} timeValue={deliveryDueDateTime}
                                onDateChange={deliveryDueDateChanged}
                                timeOptions={deliveryDueDateHours}/>
                             </div>
                             <ConditionalBlock condition={validationErrorMessage.deliveryDueDate}>
                                <p className='textDanger'>{validationErrorMessage.deliveryDueDate}</p>
                            </ConditionalBlock>
                        </div>
                    </div>

                </div>
              </div>
        </>
    );
}